export default class Languages {
    constructor(languages) {
        const { lang, url } = languages;
        this.lang = lang ? lang : '';
        this.url = url ? url : '';
    }
}
